<template>
  <fragment>
    <div class="container-xs">
      <div class="md">
        <VueShowdown v-if="articleContent" :markdown="articleContent"></VueShowdown>
      </div>
    </div>
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
// import sections
// import CGenericSection from "@/components/sections/GenericSection.vue";
// import CCta from "@/components/sections/Cta.vue";

export default {
  name: "Secondary",
  components: {
    // CGenericSection
    // CCta
  },
  props: { articleId: { type: String, required: true } },
  data() {
    return {
      fileContent: null,
      articleContent: null
    };
  },
  created() {
    // console.log("In articles detail .vue, article id is", this.articleId);

    this.getArticle(this.articleId);

    this.$emit("update:layout", CLayout);
  },
  methods: {
    async getArticle(path) {
      // console.log("About to get article", path);

      const res = await fetch("/articles-md/" + path + ".md").then(
        async response => {
          return await response.text();
        }
      );

      if (res) this.articleContent = res;
    }
  }
};
</script>

<style lang="scss">
.md {
  h1 {
    margin: 0;
  }
}
</style>